import { render, staticRenderFns } from "./SystemNews.vue?vue&type=template&id=485e160f&scoped=true"
import script from "./SystemNews.vue?vue&type=script&lang=js"
export * from "./SystemNews.vue?vue&type=script&lang=js"
import style0 from "./SystemNews.vue?vue&type=style&index=0&id=485e160f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485e160f",
  null
  
)

export default component.exports